import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UserHelperService from '../../services/UserHelperService';
import { Fragment } from 'react';
import { FormControl, TextField, Autocomplete, Chip, CircularProgress, Input, InputAdornment, OutlinedInput, Grid } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import FieldNames from '../../defaults/FieldNames.json';
import FeatureService from '../../services/FeatureService';
import { removeLeadingZeros, removeLetters, removeNegative } from "../../utils/FormatHelper";
import { removeDecimal } from "../../utils/FormatHelper";
import { currencyFormat } from "../../utils/FormatHelper";
import DetailsPopover from '../details/customPanels/DetailsPopover';
import { sumCostsMultiFunding } from '../../utils/CostsHelper';

const BlueAlien = "#1976d2";

const useStyles = makeStyles({
  underline: {
    "&&&:before": {
      borderBottom: "2px solid red"
    },
    "&&:after": {
      borderBottom: "2px solid red"
    }
  },
  condensedFormControl: {
    margin: "5px 15px 5px 15px",
    minWidth: 120,
    width: '90%'
  },
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '90%'
  },
  snackBarStyle: {
    top: '120px !important'
  },
});

const theme = createTheme({
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: 'green'
      }
    },
    MuiOutlinedInput: {
      root: {
        '& $notchedOutline': {
          //initial border
          borderColor: BlueAlien,
        },
        '&:hover $notchedOutline': {
          //border on hover
          borderColor: BlueAlien,
          border: '2px solid'
        },
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: BlueAlien,
          border: '2px solid'
        },
      },
    }
  },
});

export default function RecordCostAssignment({selectedRow, setSelectedRow, personnelCost, setPersonnelCost, otherCost, setOtherCost,
  assetCost, setAssetCost, grantsFixedCost, setGrantsFixedCost, contractualCost, 
  setContractualCost, totalCost, setTotalCost, isTreatment, isActual, isNew, requiredFields, isPoint, fundingCostValid, setFundingCostValid}) {
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
  const classes = useStyles();

  useEffect(() => {
  }, [config, rootServiceUrl]);
  
  // useEffect(() => {
  //   if(currencyValue === ""){
  //     setValue("");
  //   } else {
  //     if(currencyValue === null || currencyValue === undefined){
  //       //Adding a zero here only populates the 0 in the field, not in the treatment/activity
  //       setValue("");
  //     } else {
  //       const newFormat = currencyFormat(currencyValue.toString());
  //       setValue(newFormat);
  //     }
  //   }
  // }, [currencyValue]);

  useEffect(() => {
    if(selectedRow){
      if(selectedRow[FieldNames.fundingFields.personnelCost] === ""){
        setPersonnelCost(0);
      } else {
        if(selectedRow[FieldNames.fundingFields.personnelCost] === null || selectedRow[FieldNames.fundingFields.personnelCost] === undefined){
          setPersonnelCost(0);
        } else {
          const newFormat = currencyFormat(selectedRow[FieldNames.fundingFields.personnelCost].toString());
          setPersonnelCost(newFormat);
        }
      }
    } else {
      setPersonnelCost(0);
    }
  }, [selectedRow, setPersonnelCost]);

  useEffect(() => {
    if(selectedRow){
      if(selectedRow[FieldNames.fundingFields.otherCost] === ""){
        setOtherCost(0);
      } else {
        if(selectedRow[FieldNames.fundingFields.otherCost] === null || selectedRow[FieldNames.fundingFields.otherCost] === undefined){
          setOtherCost(0);
        } else {
          const newFormat = currencyFormat(selectedRow[FieldNames.fundingFields.otherCost].toString());
          setOtherCost(newFormat);
        }
      }
    } else {
      setOtherCost(0);
    }
  }, [selectedRow, setOtherCost]);

  useEffect(() => {
    if(selectedRow){
      if(selectedRow[FieldNames.fundingFields.grantsFixedCost] === ""){
        setGrantsFixedCost(0);
      } else {
        if(selectedRow[FieldNames.fundingFields.grantsFixedCost] === null || selectedRow[FieldNames.fundingFields.grantsFixedCost] === undefined){
          setGrantsFixedCost(0);
        } else {
          const newFormat = currencyFormat(selectedRow[FieldNames.fundingFields.grantsFixedCost].toString());
          setGrantsFixedCost(newFormat);
        }
      }
    } else {
      setGrantsFixedCost(0);
    }
  }, [selectedRow, setGrantsFixedCost]);

  useEffect(() => {
    if(selectedRow){
      if(selectedRow[FieldNames.fundingFields.assetCost] === ""){
        setAssetCost(0);
      } else {
        if(selectedRow[FieldNames.fundingFields.assetCost] === null || selectedRow[FieldNames.fundingFields.assetCost] === undefined){
          setAssetCost(0);
        } else {
          const newFormat = currencyFormat(selectedRow[FieldNames.fundingFields.assetCost].toString());
          setAssetCost(newFormat);
        }
      }
    } else {
      setAssetCost(0);
    }
  }, [selectedRow, setAssetCost]);

  useEffect(() => {
    if(selectedRow){
      if(selectedRow[FieldNames.fundingFields.contractualCost] === ""){
        setContractualCost(0);
      } else {
        if(selectedRow[FieldNames.fundingFields.contractualCost] === null || selectedRow[FieldNames.fundingFields.contractualCost] === undefined){
          setContractualCost(0);
        } else {
          const newFormat = currencyFormat(selectedRow[FieldNames.fundingFields.contractualCost].toString());
          setContractualCost(newFormat);
        }
      }
    } else {
      setContractualCost(0);
    }
  }, [selectedRow, setContractualCost]);

  useEffect(() => {
    if(selectedRow){
      if(selectedRow[FieldNames.fundingFields.totalCost] === ""){
        setTotalCost(0);
      } else {
        if(selectedRow[FieldNames.fundingFields.totalCost] === null || selectedRow[FieldNames.fundingFields.totalCost] === undefined){
          setTotalCost(0);
        } else {
          const newFormat = currencyFormat(selectedRow[FieldNames.fundingFields.totalCost].toString());
          setTotalCost(newFormat);
        }
      }
    } else {
      setTotalCost(0);
    }
  }, [selectedRow, setTotalCost]);

  useEffect(() => {
    if (typeof totalCost === "string") {
      totalCost = parseInt(totalCost.replace(/,/g, ""), 10)
    }
    setFundingCostValid( totalCost > 0);
  }, [selectedRow, totalCost]);

  return (
    <Fragment>
      <FormControl variant="standard" className={classes.formControl}>
        <ThemeProvider theme={theme}>
          <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
            <Grid item size={6}>
              <span>
                <label>Personnel Cost</label>
                {requiredFields.includes(FieldNames.featureFields.estimatedPersonnelCost) &&
                  <span className="required">*</span>
                }
                <DetailsPopover mode={"edit"} field={FieldNames.featureFields.estimatedPersonnelCost} isTreatment={isTreatment} categoryValue={null} isPoint={isPoint ? FieldNames.yesNo.yes : FieldNames.yesNo.no} isActuals={isActual} agencyValue={null} isBulkApproval={false} />
              </span>
            </Grid>
            <Grid item size={6}>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={personnelCost}
                fullWidth
                onChange={(event) => {
                  const leadingZeroFreeValue = removeLeadingZeros(event.target.value);
                  const decimalFreeValue = removeDecimal(leadingZeroFreeValue);
                  const negativeFreeValue = removeNegative(decimalFreeValue);
                  const letterFreeValue = removeLetters(negativeFreeValue);
                  const commasAdded = currencyFormat(letterFreeValue);
                  setPersonnelCost(commasAdded);
                  const newTotalCost = sumCostsMultiFunding(assetCost, grantsFixedCost, contractualCost, otherCost, commasAdded);
                  setTotalCost(currencyFormat(newTotalCost))
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </FormControl>
      <FormControl variant="standard" className={classes.formControl}>
        <ThemeProvider theme={theme}>
          <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
            <Grid item size={6}>
              <span>
                <label>Grants Fixed Cost</label>
                {requiredFields.includes(FieldNames.featureFields.estimatedGrantsFixedCost) &&
                  <span className="required">*</span>
                }
                <DetailsPopover mode={"edit"} field={FieldNames.featureFields.estimatedGrantsFixedCost} isTreatment={isTreatment} categoryValue={null} isPoint={isPoint ? FieldNames.yesNo.yes : FieldNames.yesNo.no} isActuals={isActual} agencyValue={null} isBulkApproval={false} />
              </span>
            </Grid>
            <Grid item size={6}>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={grantsFixedCost}
                fullWidth
                onChange={(event) => {
                  const leadingZeroFreeValue = removeLeadingZeros(event.target.value);
                  const decimalFreeValue = removeDecimal(leadingZeroFreeValue);
                  const negativeFreeValue = removeNegative(decimalFreeValue);
                  const letterFreeValue = removeLetters(negativeFreeValue);
                  const commasAdded = currencyFormat(letterFreeValue);
                  setGrantsFixedCost(commasAdded);
                  const newTotalCost = sumCostsMultiFunding(assetCost, commasAdded, contractualCost, otherCost, personnelCost);
                  setTotalCost(newTotalCost)
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </FormControl>
      <FormControl variant="standard" className={classes.formControl}>
        <ThemeProvider theme={theme}>
          <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
            <Grid item size={6}>
              <span>
                <label>Asset Cost</label>
                {requiredFields.includes(FieldNames.featureFields.estimatedAssetCost) &&
                  <span className="required">*</span>
                }
                <DetailsPopover mode={"edit"} field={FieldNames.featureFields.estimatedAssetCost} isTreatment={isTreatment} categoryValue={null} isPoint={isPoint ? FieldNames.yesNo.yes : FieldNames.yesNo.no} isActuals={isActual} agencyValue={null} isBulkApproval={false} />
              </span>
            </Grid>
            <Grid item size={6}>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={assetCost}
                fullWidth
                onChange={(event) => {
                  const leadingZeroFreeValue = removeLeadingZeros(event.target.value);
                  const decimalFreeValue = removeDecimal(leadingZeroFreeValue);
                  const negativeFreeValue = removeNegative(decimalFreeValue);
                  const letterFreeValue = removeLetters(negativeFreeValue);
                  const commasAdded = currencyFormat(letterFreeValue);
                  setAssetCost(commasAdded);
                  const newTotalCost = sumCostsMultiFunding(commasAdded, grantsFixedCost, contractualCost, otherCost, personnelCost);
                  setTotalCost(newTotalCost)
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </FormControl>
      <FormControl variant="standard" className={classes.formControl}>
        <ThemeProvider theme={theme}>
          <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
            <Grid item size={6}>
              <span>
                <label>Contractual Cost</label>
                {requiredFields.includes(FieldNames.featureFields.estimatedContractualCost) &&
                  <span className="required">*</span>
                }
                <DetailsPopover mode={"edit"} field={FieldNames.featureFields.estimatedContractualCost} isTreatment={isTreatment} categoryValue={null} isPoint={isPoint ? FieldNames.yesNo.yes : FieldNames.yesNo.no} isActuals={isActual} agencyValue={null} isBulkApproval={false} />
              </span>
            </Grid>
            <Grid item size={6}>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={contractualCost}
                fullWidth
                onChange={(event) => {
                  const leadingZeroFreeValue = removeLeadingZeros(event.target.value);
                  const decimalFreeValue = removeDecimal(leadingZeroFreeValue);
                  const negativeFreeValue = removeNegative(decimalFreeValue);
                  const letterFreeValue = removeLetters(negativeFreeValue);
                  const commasAdded = currencyFormat(letterFreeValue);
                  setContractualCost(commasAdded);
                  const newTotalCost = sumCostsMultiFunding(assetCost, grantsFixedCost, commasAdded, otherCost, personnelCost);
                  setTotalCost(newTotalCost)
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </FormControl>
      <FormControl variant="standard" className={classes.formControl}>
        <ThemeProvider theme={theme}>
          <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
            <Grid item size={6}>
              <span>
                <label>Other Cost</label>
                {requiredFields.includes(FieldNames.featureFields.estimatedOtherCost) &&
                  <span className="required">*</span>
                }
                <DetailsPopover mode={"edit"} field={FieldNames.featureFields.estimatedOtherCost} isTreatment={isTreatment} categoryValue={null} isPoint={isPoint ? FieldNames.yesNo.yes : FieldNames.yesNo.no} isActuals={isActual} agencyValue={null} isBulkApproval={false} />
              </span>
            </Grid>
            <Grid item size={6}>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={otherCost}
                fullWidth
                onChange={(event) => {
                  const leadingZeroFreeValue = removeLeadingZeros(event.target.value);
                  const decimalFreeValue = removeDecimal(leadingZeroFreeValue);
                  const negativeFreeValue = removeNegative(decimalFreeValue);
                  const letterFreeValue = removeLetters(negativeFreeValue);
                  const commasAdded = currencyFormat(letterFreeValue);
                  setOtherCost(commasAdded)
                  const newTotalCost = sumCostsMultiFunding(assetCost, grantsFixedCost, contractualCost, commasAdded, personnelCost);
                  setTotalCost(newTotalCost)
                }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </FormControl>
      <FormControl variant="standard" className={classes.formControl}>
        <ThemeProvider theme={theme}>
          <Grid item size={12}  container direction="row" className="grid-item" style={{ alignItems: 'center' }}>
            <Grid item size={6}>
              <span>
                <label>Total Cost</label>
                {requiredFields.includes(FieldNames.featureFields.estimatedTotalCost) &&
                  <span className="required">*</span>
                }
                <DetailsPopover mode={"edit"} field={FieldNames.featureFields.estimatedTotalCost} isTreatment={isTreatment} categoryValue={null} isPoint={isPoint ? FieldNames.yesNo.yes : FieldNames.yesNo.no} isActuals={isActual} agencyValue={null} isBulkApproval={false} />
              </span>
            </Grid>
            <Grid item size={6}>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={totalCost}
                fullWidth
                disabled={true}
                // onChange={(event) => {
                //   const decimalFreeValue = removeDecimal(event.target.value);
                //   const negativeFreeValue = removeNegative(decimalFreeValue);
                //   const letterFreeValue = removeLetters(negativeFreeValue);
                //   const commasAdded = currencyFormat(letterFreeValue);
                //   setTotalCost(commasAdded)
                // }}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
            </Grid>
          </Grid>
        </ThemeProvider>
      </FormControl>
    </Fragment>
  );
}